import { IntegrationSystem } from "../../types";
import { Newsletter2GoConnectView } from "./ConnectView";
import { Newsletter2GoSettingsView } from "./SettingsView";

export const Newsletter2GoSystem: IntegrationSystem = {
  ConnectView: Newsletter2GoConnectView,
  SettingsView: Newsletter2GoSettingsView
};
